import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthEmailVerifyRequestBody, AuthEmailVerifyResponse } from "./types";

export class AuthEmailVerifyAPI extends BaseAPI<
  AuthEmailVerifyRequestBody,
  AuthEmailVerifyResponse
> {
  protected route = ApiRoutes.auth.email_verify;
  protected method = RequestMethod.POST;
  protected displayError = false;
}

